import React from 'react';
import { connect } from 'react-redux';
import Grid from '@mui/material/Grid';
import { usePreRegisterGiftSimDalefon } from './hooks/usePreRegisterGiftSimDalefon';
import CustomDialog from 'widgets/component/CustomDialog';
import PreRegisterGiftSimsForm from './components/PreRegisterGiftSimsForm';
import { preRegisterGiftSimDalefonAction } from '_models/redux/pre-register-gift-sim-dalefon/action';
import { cleanPreRegisterGiftSimDalefon } from '_models/redux/pre-register-gift-sim-dalefon/clean-action';

const PagePreRegisterGiftSimDalefon = ({
  preRegisterGiftSimDalefonAction,
  preRegisterGiftSimDalefon,
  cleanPreRegisterGiftSimDalefon,
  onClose,
}) => {
  const {
    onSubmit,
    isDialogOpen,
    dialogMessage,
    handleClose,
    errorMessage,
    loading,
    processCompleted,
    setProcessCompleted,
  } = usePreRegisterGiftSimDalefon({
    preRegisterGiftSimDalefonAction,
    preRegisterGiftSimDalefon,
    cleanPreRegisterGiftSimDalefon,
    onClose,
  });

  return (
    <>
      <Grid>
        <h3>Pre registro de SIMs de regalo Dalefon</h3>
      </Grid>
      <hr />
      <Grid marginBottom={4} sx={{ width: '100rem' }}>
        <PreRegisterGiftSimsForm
          onSubmit={onSubmit}
          loading={loading}
          processCompleted={processCompleted}
          setProcessCompleted={setProcessCompleted}
        />
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </Grid>
      <hr />

      <CustomDialog
        title='Mensaje'
        content={<p>{dialogMessage}</p>}
        open={isDialogOpen}
        onClose={handleClose}
        fullWidth
        maxWidth='sm'
        extraButtons={[
          {
            label: 'Aceptar',
            variant: 'contained',
            onClick: handleClose,
            buttonColor: 'purple',
            textColor: 'white',
          },
        ]}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  preRegisterGiftSimDalefon: state?.preRegisterGiftSimDalefon,
});

const mapDispatchToProps = {
  preRegisterGiftSimDalefonAction,
  cleanPreRegisterGiftSimDalefon,
};

export default connect(mapStateToProps, mapDispatchToProps)(PagePreRegisterGiftSimDalefon);
